import BaseColorGroup from './BaseColorGroup';
import './BaseColorGroup.scss';
export default BaseColorGroup;
